import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "lucide-react";
import { AbsenceManager } from "@/features/rh/conges/components/AbsenceManager";

export const Route = createFileRoute("/_app/rh/conges/")({
  loader: requirePermission(PERMISSIONS.RH.CONGES.VIEW),
  staticData: {
    title: "Congés",
    icon: Calendar,
    tab_icon: Calendar,
    permission: PERMISSIONS.RH.CONGES.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 50,
    showInNav: true,
    showInTab: true,
  },
  component: AbsenceManager,
});
